import { readSessionTokenWithMigration } from "./Config";

export type KeycloakTokenPayload = {
  sub?: string;
  realm_access?: { roles?: string[] };
  preferred_username?: string;
  email?: string;
};

/** Décodage payload (UTF-8), aligné sur `frontend` / `GetJwtTokenAsJson`. */
function decodeJwtPayload(raw: string): KeycloakTokenPayload | null {
  if (raw == null || raw === "") {
    return null;
  }
  try {
    const parts = raw.split(".");
    if (parts.length < 2) {
      return null;
    }
    const base64 = parts[1]!.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    return JSON.parse(json) as KeycloakTokenPayload;
  } catch {
    return null;
  }
}

/**
 * Comme le portail : `token` explicite ou, si omis, jeton en session (migration
 * d’ancienne clé incluse).
 */
export function GetJwtTokenAsJson(token: string | null = null): KeycloakTokenPayload | null {
  const stored = token == null ? readSessionTokenWithMigration() : token;
  if (stored == null || stored === "") {
    return null;
  }
  return decodeJwtPayload(stored);
}
